import React from "react";
import ServicesCard from "./ServicesCard";
import { services } from "../../data/services";

// Below "lgl" (1024px): a horizontal swipe strip of self-contained cards —
// four competencies scanned in a few swipes instead of four full paragraphs
// stacked under a lopsided divider border meant for a 2-column grid. At
// "lgl" and up: unchanged, the original 2x2 grid (ServicesCard as-is).
const MyServices = () => {
  return (
    <div className="w-full min-w-0 mb-4 lgl:mb-0">
      <p className="lgl:hidden text-xs text-faintColor px-6 -mt-1 mb-2">
        Swipe to explore →
      </p>
      <div className="w-full min-w-0 flex gap-4 overflow-x-auto snap-x snap-mandatory pb-3 scrollbar-thin scrollbar-thumb-scrollThumb lgl:hidden">
        {services.map(({ icon, title, subTitle }) => (
          <div
            key={title}
            className="shrink-0 snap-start w-60 sm:w-64 rounded-2xl border border-lineColor bg-surfaceColor flex flex-col items-center text-center gap-2 px-5 py-6"
          >
            <span className="text-3xl text-designColor mb-1">{icon}</span>
            <h2 className="font-titleFont text-base font-semibold text-strongColor">
              {title}
            </h2>
            <p
              className="clamp-mobile text-sm text-mutedColor"
              style={{ "--clamp-lines": 3 }}
            >
              {subTitle}
            </p>
          </div>
        ))}
      </div>

      <div className="hidden lgl:grid grid-cols-1 md:grid-cols-2 gap-6 p-4">
        {services.map(({ icon, title, subTitle }) => (
          <ServicesCard key={title} icons={icon} title={title} subTitle={subTitle} />
        ))}
      </div>
    </div>
  );
};

export default MyServices;
